(
    function (skyward, $)
    {
        skyward.ecommerce = skyward.ecommerce || {};
        var launched = false;
        var init = function (selector)
        {
            var fireAssignAccountingsWorkflow = $('#FireAssignAccountingsWorkflow').val();
            var fireMyAssignAccountingsWorkflow = $('#FireMyAssignAccountingsWorkflow').val();

            if (fireAssignAccountingsWorkflow && fireAssignAccountingsWorkflow.toLowerCase() === 'true')
            {
                $(startAssignAccountingsWorkflow(false));
            }
            else if (fireMyAssignAccountingsWorkflow && fireMyAssignAccountingsWorkflow.toLowerCase() === 'true')
            {
                $(startAssignAccountingsWorkflow(true));
            }
        };

        var startAssignAccountingsWorkflow = function (isMyAssignAccountings)
        {
            if (launched)
            {
                return;
            }

            var purchaseOrderIDSecurityHash = $('#PurchaseOrderIDSecurityHash').val();
            var purchaseOrderID = $('#PurchaseOrderID').val();

            var data =
            {
                "Workflow.PurchaseOrderID": purchaseOrderID,
                "Workflow.PurchaseOrderID_securityhash": purchaseOrderIDSecurityHash
            };

            var workflowName = isMyAssignAccountings ? "Create/Purchasing/PurchaseOrder/MyAssignAccountings" : "Create/Purchasing/PurchaseOrder/AssignAccountings";

            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', workflowName, null, data, null, null, null, false, null, null, null);
            launched = true;
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
